export const customerClaim = 'https://claims.cimpress.io/is_customer';
export const canonicalIDClaim = 'https://claims.cimpress.io/canonical_id';
export const anonymousClaim = 'https://claims.cimpress.io/is_anonymous';
export const cimpressInternalClaim = 'https://claims.cimpress.io/cimpress_internal';
export const wasClaim = 'https://claims.cimpress.io/was';
//# sourceMappingURL=constants.js.map